import full from './brand/felixmate.svg';
import compact from './brand/felixmate-compact.svg';
import compactDark from './brand/felixmate-compact-dark.svg';
import fullDark from './brand/felixmate-dark.svg';
import icon from './brand/felixmate-icon.svg';
import iconDark from './brand/felixmate-icon-dark.svg';
import classes from './Logo.module.css';

/**
 * Felixmate logosunun varyantı (docs/logo-degisimi.md "Hangi yerde hangisi"): `icon` yalnız ikon,
 * `compact` ikon + "Felixmate" (menü, başlık çubuğu), `full` sloganlı tam logo (giriş ekranının
 * büyük alanı, About).
 */
export type LogoVariant = 'icon' | 'compact' | 'full';

/** Açık ve koyu zemin dosyaları; tek kaynak `packages/ui/src/brand/` (sahip, 2026-10-28). */
export const LOGO_FILES: Readonly<Record<LogoVariant, { light: string; dark: string }>> = {
  icon: { light: icon, dark: iconDark },
  compact: { light: compact, dark: compactDark },
  full: { light: full, dark: fullDark },
};

/** Görüntü alanı oranı (genişlik / yükseklik); düzen kaymasın diye genişlik baştan verilir. */
const ASPECT: Readonly<Record<LogoVariant, number>> = {
  icon: 1,
  compact: 1954 / 412,
  full: 2009 / 412,
};

export interface LogoProps {
  /** Logonun yüksekliği, piksel. */
  size?: number;
  /** Ürün adını gösterir: kompakt logo; `false` yalnız ikon. `variant` verilirse o kullanılır. */
  withWordmark?: boolean;
  variant?: LogoVariant;
  /** Koyu zemin (menü, giriş paneli): beyaz yazılı, ikonu açık kenarlı varyant. */
  inverted?: boolean;
  productName?: string;
}

/** Felixmate logosu (ürün adı, sahip kararı 2026-10-28). Şirket markası ayrıdır (ADR 0019 §4). */
export function Logo({
  size = 36,
  withWordmark = true,
  variant,
  inverted = false,
  productName = 'Felixmate',
}: LogoProps) {
  const kind: LogoVariant = variant ?? (withWordmark ? 'compact' : 'icon');
  const file = LOGO_FILES[kind][inverted ? 'dark' : 'light'];
  return (
    <img
      className={classes.root}
      src={file}
      alt={productName}
      height={size}
      width={Math.round(size * ASPECT[kind])}
      data-variant={kind}
      data-inverted={inverted || undefined}
      draggable={false}
    />
  );
}
